export const columns = [
  {
    field: "InvestigationDate",
    name: "Investigation Date",
  },
  {
    field: "InvestigatorName",
    name: "Investigator Name",
  },
  {
    field: "CaseStatus",
    name: "Case Status",
  },
  {
    field: "Remarks",
    name: "Remarks",
  },
]

export const PersInformation_Table_columns = [
  //  {
  //        field: "CnicNo",
  //        name: "CnicNo",
  //      },

  //      {
  //        field: "ApplicantName",
  //        name: "Applicant Name",
  //      },
  {
    field: "FatherName",
    name: "Father Name",
  },
  {
    field: "DateOfBirth",
    name: "Date Of Birth",
  },
  {
    field: "Gender",
    name: "Gender",
  },

  // {
  //   field: "ApplicantCaseCode",
  //   name: "App Case Code",
  // },
  // {
  //   field: "PrimaryContactNo",
  //   name: "Primary ContactNo",
  // },

  {
    field: "AlternateContactNo",
    name: "Alternate ContactNo",
  },

  {
    field: "CaseNature",
    name: "Case Nature",
  },

  {
    field: "City",
    name: "City",
  },

  {
    field: "Area",
    name: "Area",
  },

  {
    field: "CaseTitle",
    name: "CaseTitle",
  },

  {
    field: "CaseExpiry",
    name: "CaseExpiry",
  },

  {
    field: "IsCaseofthe_Day",
    name: "Case Day",
  },

  {
    field: "IsCaseShow",
    name: "Case Show",
  },

  {
    field: "NoofFamilyAccompanying",
    name: "NoofFamily Accompanying",
  },

  {
    field: "NoofHouseholdMember",
    name: "NoofHouse holdMember",
  },

  {
    field: "TemperoryAddresss",
    name: "Temperory Addresss",
  },

  {
    field: "PermanentAddress",
    name: "Permanent Address",
  },

  {
    field: "FamilyNumber",
    name: "Family Number",
  },
  {
    field: "PrimaryFundCat",
    name: "Primary Fund Cat",
  },
  {
    field: "FundAmount_Required",
    name: "Fund Amount Required",
  },

  {
    field: "IsJoinFamily",
    name: "IsJoinFamily",
  },
]

export const FamilyInfo_Columns = [
  {
    field: "Name",
    name: "Name",
  },
  {
    field: "CNIC_B_FormNumber",
    name: "CNIC/B Form Number",
  },
  {
    field: "Mother_Father_HusbandName",
    name: "Mother/Father/Husband Name",
  },
  {
    field: "DateOfBirth",
    name: "Date Of Birth",
  },
  {
    field: "DateOfDeath",
    name: "Date Of Death",
  },

  {
    field: "Religion",
    name: "Religion",
  },

  {
    field: "Gender",
    name: "Gender",
  },
  {
    field: "Marital_Status",
    name: "Marital Status",
  },

  {
    field: "Contact_Type",
    name: "Contact Type",
  },

  {
    field: "Contact_Number",
    name: "Contact Number",
  },

  {
    field: "Remarks",
    name: "Remarks",
  },

  {
    field: "CanRead",
    name: "CanRead",
  },

  {
    field: "CanWrite",
    name: "CanWrite",
  },

  {
    field: "IsEmployeed",
    name: "Is Employed",
  },

  {
    field: "JobRemarks",
    name: "Job Remarks",
  },

  {
    field: "LastWorkExperience",
    name: "Last Work Experience",
  },

  {
    field: "IsPartOfBannedOrg",
    name: "Part Of BannedOrg",
  },

  {
    field: "IsInvolveInCriminalActivity",
    name: "Criminal Activity",
  },

  {
    field: "HasMedicalHistory",
    name: "Medical History",
  },
]

export const EducationDetails_Columns = [
  {
    field: "StudentName",
    name: "Student Name",
  },
  {
    field: "Academic",
    name: "Academic",
  },
  {
    field: "ProgramName",
    name: "Program Name",
  },
  {
    field: "Degree",
    name: "Degree",
  },
  {
    field: "ClassyearSemester",
    name: "Class year Semester",
  },

  {
    field: "Grade_Percentage_CGPA_Marks",
    name: "Grade Percentage CGPA Marks",
  },

  {
    field: "YearOfCompletion",
    name: "Year Of Completion",
  },

  {
    field: "Location",
    name: "Location",
  },

  {
    field: "Educational_ContactNo",
    name: "Educational ContactNo",
  },

  {
    field: "NameOfInstitute",
    name: "Name Of Institute",
  },
]

export const MedicalDetails_Columns = [
  {
    field: "FamilyMemberName",
    name: "Name Of Patient",
  },
  {
    field: "Eligible",
    name: "Eligible/Disability/Disase",
  },
  {
    field: "Amount",
    name: "Amount",
  },
  {
    field: "HospitalName",
    name: "Hospital Name",
  },

  {
    field: "HospitalContactNo",
    name: "Hospital ContactNo",
  },
  {
    field: "HospitalAddress",
    name: "Hospital Address",
  },

  {
    field: "DoctorName",
    name: "Doctor Name",
  },

  {
    field: "DoctorContactNo",
    name: "Doctor ContactNo",
  },
]

export const Guardian_Columns = [
  {
    field: "GuardianCnic",
    name: "Guardian Cnic",
  },
  {
    field: "GuardianName",
    name: "Guardian Name",
  },

  {
    field: "GuardianContactNo",
    name: "Guardian Contact No",
  },

  {
    field: "Occupation",
    name: "Occupation",
  },

  {
    field: "Relation",
    name: "Relation",
  },

  {
    field: "CompanyName",
    name: "Company Name",
  },
]

export const MonthlyExpanse_Columns = [
  {
    field: "Expnse",
    name: "Expense",
  },
  {
    field: "Remarks",
    name: "Remarks",
  },
  {
    field: "Amount",
    name: "Amount",
  },
]

export const Earnings_Columns = [
  {
    field: "FamilyMemberName",
    name: "FamilyMemberName",
  },
  {
    field: "JobStatus",
    name: "JobStatus",
  },
  {
    field: "EarningAmount",
    name: "Earning Amount",
  },

  {
    field: "JobRole",
    name: "Job Role",
  },
  {
    field: "LastCompanyName",
    name: "Employer",
  },
  {
    field: "Remarks",
    name: "Remarks",
  },
]

export const AssetInformation_Columns = [
  { field: "AssetTypeName", name: "Asset Type" },
  { field: "AssetSubTypeName", name: "Asset Details" },
  { field: "AssetStatusName", name: "Asset Status" },
  { field: "AreaPerSqMtr", name: "Area Per Square Meter" },
  { field: "MortgageLandLordName", name: "Owner Name" },
  { field: "MortgageLandLordContactNo", name: "Contact Number" },
  { field: "MortgageLandLordAddress", name: "Address" },
  {
    field: "CreatedDate",
    name: "Created Date",
    type: "date",
  },
]
// export const AssetInformation_Columns = [
//   {
//     field: "AssetInfoType",
//     name: "Asset Information Type",
//   },
//   {
//     field: "AssetType",
//     name: "AssetType",
//   },

//   {
//     field: "AssetSubType",
//     name: "Asset Sub Type",
//   },

//   {
//     field: "Mortgagee_LandlordName",
//     name: "Mortgagee Landlord Name",
//   },

//   {
//     field: "Mortagagee_LandlordContactNumber",
//     name: "Mortagagee Land lord Contact Number",
//   },

//   {
//     field: "Mortgagee_LandlordAddress",
//     name: "Mortgagee LandlordAddress",
//   },

//   {
//     field: "AssetStatus",
//     name: "AssetStatus",
//   },
//   {
//     field: "AreaPerSqMtr",
//     name: "Area Per Square Meter",
//   },
// ]

export const LoanComatee_Columns = [
  {
    field: "loantype",
    name: "loan type",
  },
  {
    field: "LoanAmount",
    name: "Loan Amount",
  },

  {
    field: "BalanceAmount",
    name: "Balance Amount",
  },

  {
    field: "Remarks",
    name: "Remarks",
  },
]

export const Pets_Columns = [
  {
    field: "PetName",
    name: "Pet Name",
  },
  {
    field: "Quantity",
    name: "Quantity",
  },
]

export const SourceofDrinkwater_Columns = [
  {
    field: "typeName",
    name: "type Name",
  },
  {
    field: "typedetailname",
    name: "Type detail name",
  },
]

export const PrimarySupport_Columns = [
  // {
  //   field: "Sr#",
  //   name: "Sr #",
  // },
  {
    field: "familyMemberName",
    name: "Family Member",
  },

  {
    field: "relationName",
    name: "Self/Relation",
  },

  {
    field: "categoryName",
    name: "Fund Category",
  },

  {
    field: "fundCategoryName",
    name: "Fund Sub Category",
  },

  {
    field: "frequencyName",
    name: "Frequency",
  },

  {
    field: "fundRequired",
    name: "Fund Required",
  },

  {
    field: "repeatition",
    name: "Repetition",
  },

  {
    field: "totalFundAmount",
    name: "Total Fund Amount",
  },
]

export const SecondarySupport_Columns = [
  {
    field: "familyMemberName",
    name: "Family Member",
  },

  {
    field: "relationName",
    name: "Self/Relation",
  },

  {
    field: "categoryName",
    name: "Fund Category",
  },

  {
    field: "fundCategoryName",
    name: "Fund Sub Category",
  },

  {
    field: "frequencyName",
    name: "Frequency",
  },

  {
    field: "fundRequired",
    name: "Fund Required",
  },

  {
    field: "repeatition",
    name: "Repetition",
  },

  {
    field: "totalFundAmount",
    name: "Total Fund Amount",
  },
]

export const ApprovalHistory_Columns = [
  {
    field: "ActionBy",
    name: "Action By",
  },
  {
    field: "Status",
    name: "Status",
  },
  {
    field: "AmountApproved",
    name: "Amount Approved",
  },
  {
    field: "IsEligibility",
    name: "Eligibility",
  },
  {
    field: "RestrictedFund",
    name: "Restricted Fund",
    type: "HTML",
  },
  {
    field: "Remarks",
    name: "Remarks",
  },
  {
    field: "Investigator",
    name: "Investigator",
  },
  {
    field: "CreatedDate",
    name: "Date",
  },
]
export const Approval_Columns = [
  {
    field: "FamilyMember",
    name: "FamilyMember",
  },
  {
    field: "Relation",
    name: "Self/Relation",
  },
  {
    field: "FundCategory",
    name: "Fund Category",
  },
  {
    field: "FundSubCategory",
    name: "Fund Sub Category",
  },

  {
    field: "AmountApproved",
    name: "Fund Approved",
  },

  {
    field: "ApprovedFundPercent",
    name: "%age",
  },

  {
    field: "Frequency",
    name: "Frequency",
  },

  {
    field: "TotalAmount",
    name: "Total Amount",
  },

  {
    field: "Months",
    name: "Month",
  },
]

export const columns_PaymentSchedule = [
  {
    field: "SupportType",
    name: "Support Type",
  },
  {
    field: "FundCategory",
    name: "Fund Category",
  },
  {
    field: "FundSubCategory",
    name: "Fund Sub Category",
  },
  {
    field: "PaymentSchedule_Date",
    name: "Payment Schedule Date",
  },
  {
    field: "Amount",
    name: "Amount",
  },
  {
    field: "PaymentFrequency",
    name: "Payment Frequency",
  },
]

export const columns_PaymentHistory = [
  {
    field: "VoucherNo",
    name: "Voucher No",
  },
  {
    field: "PaymentSchedule_Date",
    name: "Payment Schedule Date",
  },
  {
    field: "Amount",
    name: "Amount",
  },
  // {
  //   field: "PaymentSchedule_Date",
  //   name: "Payment Schedule Date",
  // },
  // {
  //   field: "Amount",
  //   name: "Amount",
  // },
  {
    field: "PaymentStatus",
    name: "Payment Status",
  },

  {
    field: "PaymentType",
    name: "Payment Type",
  },
  // {
  //   field: "BankName",
  //   name: "Bank Name",
  // },
  // {
  //   field: "AccountTitle",
  //   name: "Account Title",
  // },
  // {
  //   field: "AccountNumber",
  //   name: "Account No",
  // },
  // {
  //   field: "PaymentCNICNo",
  //   name: "Payee CNIC",
  // },
  // {
  //   field: "PaymentGateway",
  //   name: "Payment Gateway",
  // },

  {
    field: "ActionBy",
    name: "Action By",
  },
  // {
  //   field: "ActionDatetime",
  //   name: "Action Date",
  // },
  {
    field: "Remarks",
    name: "Remarks",
  },
]
